import appointmentListActionsConstants from '@constants/appointmentListActions.constants'

export default [
  {
    value: appointmentListActionsConstants.ATTACH_BRACES_NOTES,
    label: 'Attach braces notes',
  },
  {
    value: appointmentListActionsConstants.VIEW_SUMMARY,
    label: 'View summary',
  },
  {
    value: appointmentListActionsConstants.EDIT,
    label: 'Edit',
  },
  {
    value: appointmentListActionsConstants.DELETE_APPOINTMENT,
    label: 'Delete appointment',
  },
]
